import {
  AppBar,
  Box,
  Button,
  Grid,
  Toolbar,
  Typography,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../Components/BreadCrumb';
import { Link, useHistory } from 'react-router-dom';
import routes from '../../../Utils/routes.json';
import KenCard from '../../../global_components/KenCard';
import KenGrid from '../../../global_components/KenGrid';
import KenSelect from '../../../global_components/KenSelect';
import KenLoader from '../../../Components/KenLoader/index';
import KenDateTimePicker from '../../../global_components/KenDateTimePicker';
import { useState, useEffect } from 'react';
import {
  getCurrentBatch,
  getBatchFilter,
  getAcademicFilter,
  getAccountData,
} from '../../../Utils/apiServices';

const arrayBreadCrumb = [
  { head: 'HOME', url: routes.academicsPlanner },
  {
    head: 'CURRENT BATCHES',
  },
];

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  dateField: {
    backgroundColor: '#fff',
  },
}));

const selectOptions = [
  {
    label: 'Filter by Program',
    value: 'Filter by Program',
  },
  {
    label: 'Filter by Batch',
    value: 'Filter by Batch',
  },
  {
    label: 'Filter by Intake',
    value: 'Filter by Intake',
  },
  {
    label: 'Filter by Campus',
    value: 'Filter by Campus',
  },
  {
    label: 'Filter by Term Status',
    value: 'Filter by Term Status',
  },
];

const CurrentProgrammes = () => {
  const history = useHistory();
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectValue, setSelectValue] = useState(selectOptions[0].value);
  const [selectCampusValue, setCampusValue] = useState('');
  const [selectTermValue, setTermValue] = useState('');
  const [selectProgramValue, setProgramValue] = useState(
    sessionStorage.getItem('programName') || ''
  );
  const [selectBatchValue, setBatchValue] = useState(
    sessionStorage.getItem('year') || ''
  );
  const [selectIntakeValue, setIntakeValue] = useState(
    sessionStorage.getItem('intake') || ''
  );
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [selectIntakeOptions, setIntakeOptions] = useState([]);
  const [selectBatchOptions, setBatchOptions] = useState([]);
  const [selectProgramOptions, setProgramOptions] = useState([]);
  const [selectCampusOptions, setCampusOptions] = useState([]);
  const [selectTermOptions, setTermOptions] = useState([]);

  const ActionCell = (row) => {
    const { id, index } = row.row;
    return (
      <Box>
        <Button
          size="small"
          variant="contained"
          color="primary"
          style={{ borderRadius: 15 }}
          // component={Link}
          onClick={() => {
            history.push({
              pathname: `${routes.facultyDetails}`,
              state: {
                programName: row.data[index]?.data?.Course,
                intake: row.data[index].intake,
                year: row.data[index].batch,
                // batchName: locationData,
              },
            });
            sessionStorage.setItem(
              'programName',
              row.data[index]?.data?.Course
            );
            sessionStorage.setItem('intake', row.data[index].intake);
            sessionStorage.setItem('year', row.data[index].batch);
          }}
        >
          View Details
        </Button>
      </Box>
    );
  };

  const columns = [
    {
      Header: 'ID',
      accessor: 'id',
      disableGlobalFilter: true,
    },
    {
      Header: 'program',
      accessor: 'program',
      disableGlobalFilter: true,
    },
    {
      Header: 'batch',
      accessor: 'batch',
      disableGlobalFilter: true,
    },
    {
      Header: 'intake',
      accessor: 'intake',
      disableGlobalFilter: true,
    },
    {
      Header: 'mode',
      accessor: 'mode',
      disableGlobalFilter: true,
    },
    {
      Header: 'Start Date',
      accessor: 'start_date',
      disableGlobalFilter: true,
    },
    {
      Header: 'End Date',
      accessor: 'end_date',
      disableGlobalFilter: true,
    },
    {
      Header: 'No of Student',
      accessor: 'no_of_student',
      disableGlobalFilter: true,
    },
    {
      Header: 'Terms',
      accessor: 'semester',
      disableGlobalFilter: true,
    },
    {
      Header: 'Term Status',
      accessor: 'status',
      disableGlobalFilter: true,
    },
    {
      Header: 'Campus',
      accessor: 'campus',
      disableGlobalFilter: true,
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ActionCell,
    },
  ];

  const datas = [
    {
      id: 1,
      program: (
        <Link style={{ color: '#092682' }} to="#">
          MBA
        </Link>
      ),
      intake: 'Jan 22',
      mode: 'F2F',
      start_date: '01/01/2020',
      end_date: '31/12/2022',
      no_of_student: 450,
      semester: '3',
      campus: 'Mumbai',
      batch: 'MBA 2022',
      status: 'Ongoing',
    },
    {
      id: 2,
      program: (
        <Link style={{ color: '#092682' }} to="#">
          EMBA
        </Link>
      ),
      intake: 'Jan 22',
      mode: 'F2F',
      start_date: '01/06/2022',
      end_date: '31/05/2022',
      no_of_student: 320,
      semester: '3',
      campus: 'Singapore',
      batch: 'EMBA 2022',
      status: 'Completed',
    },
    {
      id: 3,
      program: (
        <Link style={{ color: '#092682' }} to="#">
          GMBA
        </Link>
      ),
      intake: 'Jan 22',
      mode: 'F2F',
      start_date: '01/06/2021',
      end_date: '31/05/2022',
      no_of_student: 235,
      semester: '2',
      campus: 'Mumbai',
      batch: 'GMBA 2022',
      status: 'Upcoming',
    },
    {
      id: 4,
      program: (
        <Link style={{ color: '#092682' }} to="#">
          PGPFMB
        </Link>
      ),
      intake: 'Jan 22',
      mode: 'F2F',
      start_date: '01/01/2020',
      end_date: '31/06/2022',
      no_of_student: 232,
      semester: '4',
      campus: 'Dubai',
      batch: 'PGPFMB 2022',
      status: 'Ongoing',
    },
  ];
  const handleSelectChange = (e) => {
    setSelectValue(e.target.value);
    setCampusValue('');
    setTermValue('');
    setProgramValue('');
    setBatchValue('');
    setIntakeValue('');
  };
  const handleSelectCampusChange = (e) => {
    setCampusValue(e.target.value);
  };
  const handleSelectTermChange = (e) => {
    setTermValue(e.target.value);
  };
  const handleSelectProgramChange = (e) => {
    setProgramValue(e.target.value);
    sessionStorage.setItem('programName', e.target.value);
  };
  const handleSelectBatchChange = (e) => {
    setBatchValue(e.target.value);
    sessionStorage.setItem('year', e.target.value);
  };
  const handleSelectIntakeChange = (e) => {
    setIntakeValue(e.target.value);
    sessionStorage.setItem('intake', e.target.value);
  };
  const manageStartDate = (e) => {
    setStartDate(e.target.value);
  };
  const manageEndDate = (e) => {
    setEndDate(e.target.value);
  };
  useEffect(() => {
    getAccountData().then((res) => {
      console.log(res);
      if (res.recentItems.length > 0) {
        const data = res?.recentItems.filter((item) => {
          if (item.Name === 'SP Jain School of Global Management') {
            return item;
          }
        });
        console.log("data", data)
        localStorage.setItem("userDetails", JSON.stringify(data[0]))
      }
    });
  }, []);
  useEffect(() => {
    setLoading(true);
    let filterData = {
      program: selectProgramValue,
      batch: selectBatchValue,
      intake: selectIntakeValue,
      campus: selectCampusValue,
      status: selectTermValue,
      filter: selectValue,
    };
    getCurrentBatch(filterData)
      .then((res) => {
        console.log(res);
        let data = [];
        res.map((item, index) => {
          data.push({
            id: index + 1,
            program: item.ProgramName ? item.ProgramName : 'N/A',
            intake: item.Intake ? item.Intake : 'N/A',
            mode: item.Mode ? item.Mode : 'N/A',
            start_date: item.StartDate ? item.StartDate : 'N/A',
            end_date: item.EndDate ? item.EndDate : 'N/A',
            no_of_student: item.NoOfStudent ? item.NoOfStudent : 'N/A',
            semester: item.Semester ? item.Semester : 'N/A',
            campus: item.Campus ? item.Campus : 'N/A',
            batch: item.Batch ? item.Batch : 'N/A',
            status: item.TermStatus ? item.TermStatus : 'N/A',
            data: item,
          });
        });
        setData(data);
        setLoading(false);
      })
      .catch((err) => {
        setData([]);
        setLoading(false);
      });
  }, [
    selectCampusValue,
    selectTermValue,
    selectProgramValue,
    selectBatchValue,
    selectIntakeValue,
  ]);
  useEffect(() => {
    getBatchFilter().then((res) => {
      if (res.length > 0) {
        let data = [...new Set(res.map((item) => item.ProgramName))];
        let programData = data.map((item) => ({ label: item, value: item }));
        // let data = [...new Set(res.map((item) => item.Course))];
        // let programData = data.map((item) => ({ label: item, value: item }));

        let data2 = [...new Set(res.map((item) => item.Batch))];
        let batchData = data2.map((item) => ({ label: item, value: item }));

        let data3 = [...new Set(res.map((item) => item.Intake))];
        let intakeData = data3.map((item) => ({ label: item, value: item }));

        let data4 = [...new Set(res.map((item) => item.Campus))];
        let campusData = data4.map((item) => ({ label: item, value: item }));

        let data5 = [...new Set(res.map((item) => item.TermStatus))];
        let statusData = data5.map((item) => ({ label: item, value: item }));
        // let data5 = [...new Set(res.map((item) => item?.TermStatus))];
        // let statusData = data5.map((item) => ({ label: item, value: item }));
        let updateStatus = statusData.filter((ele) => ele.label);
        console.log('updateStatus', updateStatus);

        setIntakeOptions(intakeData);
        setBatchOptions(batchData);
        // setProgramOptions(programData);
        setCampusOptions(campusData);
        setTermOptions(updateStatus);
      }
    });
    getAcademicFilter().then((res) => {
      let programData = [];
      Object.entries(res['Academic Program']).map(([item, keyVal]) => {
        programData.push({
          label: item,
          value: item,
        });
      });
      setProgramOptions(programData);
    });
  }, []);
  const CustomStyle = {
    option: (base, state) => {
      let backgroundColor = 'white';

      if (state.isSelected) {
        backgroundColor = 'red';
      }

      if (state.isFocused) {
        backgroundColor = 'blue';
      }

      return {
        ...base,
        backgroundColor,
      };
    },
  };
  return (
    <Box>
      {loading && <KenLoader />}
      <Box className={classes.breadCrumbWrapper}>
        {/* <BreadCrumb array={arrayBreadCrumb} history={history} /> */}
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            Current Batches
          </Typography>
        </Toolbar>
      </AppBar>

      <Grid container className={classes.mainActions}>
        <Grid item xs={8} style={{ display: 'flex', alignItems: 'center' }}>
          {/* <Typography>Filter By</Typography>
          <Box sx={{ maxWidth: 200 }} ml={2}>
            <KenSelect
              options={selectOptions}
              value={selectValue}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChange}
              styles={CustomStyle}
              required
            />
          </Box> */}
          {selectValue === 'Filter by Date' && (
            <>
              <Typography style={{ marginLeft: 10 }}>Start Date</Typography>
              <Box sx={{ backgroundColor: '#fff' }} ml={2}>
                <KenDateTimePicker
                  value={startDate}
                  type="date"
                  required={true}
                  defaultValue={startDate}
                  onChange={manageStartDate}
                />
              </Box>
              <Typography style={{ marginLeft: 10 }}>End Date</Typography>
              <Box sx={{ maxWidth: 160, backgroundColor: '#fff' }} ml={2}>
                <KenDateTimePicker
                  value={endDate}
                  type="date"
                  required={true}
                  defaultValue={endDate}
                  onChange={manageEndDate}
                />
              </Box>
            </>
          )}

          <>
            {/* <Typography style={{ marginLeft: 10 }}>Select Program</Typography> */}
            <Box sx={{ maxWidth: 160, width: '100%' }} ml={4}>
              <KenSelect
                label="Select Academic Program"
                options={selectProgramOptions}
                value={selectProgramValue}
                dropdownColor="#FFFFFF"
                onChange={handleSelectProgramChange}
                styles={CustomStyle}
                required
              />
            </Box>
          </>

          <>
            {/* <Typography style={{ marginLeft: 10 }}>Select Batch</Typography> */}
            <Box sx={{ maxWidth: 160, width: '100%' }} ml={2}>
              <KenSelect
                label="Select Batch"
                options={selectBatchOptions}
                value={selectBatchValue}
                dropdownColor="#FFFFFF"
                onChange={handleSelectBatchChange}
                styles={CustomStyle}
                required
              />
            </Box>
          </>

          <>
            {/* <Typography style={{ marginLeft: 10 }}>Select Intake</Typography> */}
            <Box sx={{ maxWidth: 160, width: '100%' }} ml={2}>
              <KenSelect
                label="Select Intake"
                options={selectIntakeOptions}
                value={selectIntakeValue}
                dropdownColor="#FFFFFF"
                onChange={handleSelectIntakeChange}
                styles={CustomStyle}
                required
              />
            </Box>
          </>
          <>
            {/* <Typography style={{ marginLeft: 10 }}>Select Campus</Typography> */}
            <Box sx={{ maxWidth: 160, width: '100%' }} ml={2}>
              <KenSelect
                label="Select Campus"
                options={selectCampusOptions}
                value={selectCampusValue}
                dropdownColor="#FFFFFF"
                onChange={handleSelectCampusChange}
                styles={CustomStyle}
                required
              />
            </Box>
          </>
          <>
            {/* <Typography style={{ marginLeft: 10 }}>
              Select Term Status
            </Typography> */}
            <Box sx={{ maxWidth: 160, width: '100%' }} ml={2}>
              {console.log('selectTermOptions', selectTermOptions)}
              <KenSelect
                label="Select Term Status"
                options={selectTermOptions}
                value={selectTermValue}
                dropdownColor="#FFFFFF"
                onChange={handleSelectTermChange}
                styles={CustomStyle}
                required
              />
            </Box>
          </>
        </Grid>
        <Grid item xs={4} style={{ display: 'flex', justifyContent: 'end' }}>
          <Button
            startIcon={<AddIcon />}
            variant="contained"
            color="primary"
            className={classes.addButton}
            component={Link}
            to={routes.addProgram}
          >
            Add New Program
          </Button>
        </Grid>
      </Grid>

      <Box className="cardlsitbox">
        <KenCard elevation={0}>
          <KenGrid
            columns={columns}
            data={data}
            pagination={{ disabled: false }}
            toolbarDisabled={true}
            initialState={{
              hiddenColumns: ['id'],
            }}
          />
        </KenCard>
      </Box>
    </Box>
  );
};

export default CurrentProgrammes;
